/* Presentation only: no cart handlers, no autoplay, no dependency on motion. */
(() => {
  if (window.bazV4HomeReady) return;
  window.bazV4HomeReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.b4h-heading, .b4h-product, .b4h-duo-card, .b4h-guide-card';
  const reveal = element => element.classList.remove('b4h-enter-pending');
  const init = (root = document) => {
    if (document.body.dataset.b4Motion === 'false' || reduce.matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }), { threshold: 0.02, rootMargin: '0px 0px -16px 0px' });
    root.querySelectorAll(selector).forEach(element => {
      const section = element.closest('.b4-home');
      if (!section || section.dataset.b4hMotion !== 'true' || element.dataset.b4hReady) return;
      element.dataset.b4hReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('b4h-enter', 'b4h-enter-pending');
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const element = event.target.closest('.b4h-enter-pending');
    if (element) reveal(element);
  });
  document.addEventListener('focusin', event => {
    const element = event.target.closest?.('.b4h-enter-pending');
    if (element) reveal(element);
  });
  reduce.addEventListener?.('change', event => {
    if (event.matches) document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
  });
})();
